import { combineReducers } from 'redux';

import items from './items';
import page from './page';

/**
 * @typedef {{
 *  page: import('modules/global/generic.types.js').Page,
 *  links: Array<import('modules/global/generic.types.js').Link>,
 *  items: Array<import('modules/statistics/types').DealersStatisticsReducer>
 * }} StatisticsDealersDataReducer
 */

export default combineReducers({
  page,
  items,
});
